import React, { Component } from "react";
import {mapPositionsSteps,uploadFileInstruction,mapType,reviewInstruction} from '../../../utils/constants';
import Steps from '../../../components/Steps/Steps';
import UploadFile from '../Components/UploadFile/UploadFile';
import MatchColumns from '../Components/MatchColumns/MatchColumns';
import Review from './../Components/Review/Review';
import MapColumns from './../Components/MapColumns/MapColumns';
import groupBy from 'lodash/groupBy';
import uniqBy from 'lodash/uniqBy';
import sortBy from 'lodash/sortBy';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import filter from 'lodash/filter';
import { deepClone } from "../../../utils/copyObject";
import * as url from './../../../utils/url';
import axios from './../../../axios';


export default class MapPositions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchedTerm : '',
      sortType : 'unmapped-first',
      occupationOptions : [],
      seniorityOptions : [],
      occupationErr:false,
      seniorityErr:false
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    let {allOccupationsMapping, allSeniorityMapping} = this.props.mapPositions;
    const orgID = this.props.user.organizationId._id
    let seniorityOptions
    let occupationOptions 
    axios.get(url.getMasterListByCategory('OCCUPATION')).then(({data}) => {
      const payload = data.data;
      occupationOptions = payload[0].docs.map((occupation) => {
        const o = {};
        o.value = occupation._id;
        o.label = occupation.name;
        o.definition = occupation.definition;
        return o;
      })
      occupationOptions = sortBy(occupationOptions, ['label']);
      this.setState({
        occupationOptions : occupationOptions
      })

      //   axios.get(url.getExistingMappings(orgID)).then(({data}) => {
      //     const payload = data.data;
      //     let {mapping} = payload;
      //     let existM=[]
      //     mapping.occupation.data.map(e=>{
      //       let column = e.key
      //       let obj;
      //         e.values.map(c=>{
      //           let cVal = find(this.state.occupationOptions, {label:e.key})
      //           obj = {column:{value: cVal.value, label:e.key}, value: c, mapped:true}
      //           return allOccupationsMapping.push(obj)
      //         })
      //     })
      // })

      axios.get(url.getMasterListByCategory('SENIORITY')).then(({data}) => {
        const payload = data.data;
        seniorityOptions = payload[0].docs.map((seniortiy) => {
          const o = {};
          o.value = seniortiy._id;
          o.label = seniortiy.name;
          o.definition = seniortiy.definition;
          return o;
        })
        seniorityOptions = sortBy(seniorityOptions, ['label']);
        this.setState({
          seniorityOptions : seniorityOptions
        });
      });

      })
      
      const location = this.props.history.location;

      const unblock = this.props.history.block((location, action) => {
        if (action==='POP') return "You have not completed the process yet. Are you sure you want to leave without completing it?";
        // if (action==='PUSH' && !location.pathname.startsWith(`/home/analytics/${category}/create`)) return "You have not completed the process yet. Are you sure you want to leave without completing it?";
      }); 
      // Listen for changes to the current location.
      const unlisten = this.props.history.listen((location, action) => {
      // location is an object like window.location
        // console.log(action, location.pathname, location.state);
        if(location.pathname.indexOf("success")>-1 || location.pathname.indexOf("enterprise-info/map-positions")>-1 || location.pathname.indexOf("setup/map-positions") >-1) {
          unlisten();
          unblock();  
        }
      })
  }

  handleFileUpload = (fields, data, file) => {
    const { matchedColumns } = this.props.mapPositions;
    this.props.onProcessedFileUploadData(fields, data, file);
    // console.log(matchedColumns);
    // console.log(fields);
    const columns = [];
    if(matchedColumns.length > 0) {
      const matchedOccupationColumn = find(matchedColumns,(o) => find(o.value,{value : 'occupations'}));
      // console.log(matchedOccupationColumn)
      if(matchedOccupationColumn && matchedOccupationColumn!=="undefined" && matchedOccupationColumn!==null) {
        if(fields.includes(matchedOccupationColumn.csvField)) {
          columns.push(matchedOccupationColumn);
        }
      }
      const matchedSeniorityColumn = find(matchedColumns,(o) => find(o.value,{value : 'seniority'}));
      // console.log(matchedSeniorityColumn, matchedOccupationColumn)
      if(matchedSeniorityColumn && matchedSeniorityColumn!=="undefined" && matchedSeniorityColumn!==null) {
        if(fields.includes(matchedSeniorityColumn.csvField)) {
          columns.push(matchedSeniorityColumn);
        }
      }
      this.props.onMatchColumn(columns);
    }
    this.props.nextStep();
    // console.log("on handle file upload");
  }

  handleMapOccupationColumnContinue = () => {
    let {matchedColumns, rowData,allOccupationsMapping,allSeniorityMapping} = this.props.mapPositions;
    // console.log(allSeniorityMapping)
    let {isRepeatFlow} = this.props;
    let nonNullColumns = filter(matchedColumns,(col) => col.value);
    const orgID = this.props.user.organizationId._id
    const seniorityColumn = find(nonNullColumns,(col) => {
      if(Array.isArray(col.value)) {
        if(find(col.value,{value : 'seniority'})) {
          return col;
        }
      } else {
        if(col.value.value === 'seniority') {
          return col;
        }
      }
    });
    // console.log(seniorityColumn)
 
    const invalidRecords = filter(allSeniorityMapping,(o) => o.mapped && !o.column && o.column!=="");
    // console.log('invalid ---', invalidRecords)


    let uniqueSeniority;

    uniqueSeniority =  (seniorityColumn && seniorityColumn.csvField? Object.keys(groupBy(rowData,(r) => r[seniorityColumn.csvField])):"")


    if(invalidRecords.length>0){
      this.setState({occupationErr:"Please map previously mapped values"})
      return
    } else {
      let seniority = [];
      // console.log(isRepeatFlow)


      if(isRepeatFlow) {
            axios.get(url.getExistingMappings(orgID)).then(({data}) => {
              const payload = data.data;
              // console.log(data)
              let {mapping} = payload;
              let existM=[]
          if(mapping.seniority.data.length > 0) {
            allSeniorityMapping =[]
              mapping.seniority.data.map(e=>{
                // console.log(e)
              let column = e.key
              let obj;
                e.values.map(c=>{
                  // console.log(this.state.seniorityOptions)
                  // console.log(e.key)
                  let cVal = find(this.state.seniorityOptions, {label:column})
                  // console.log(cVal)
                  obj = {column:{value: cVal.value, label:e.key}, value: c, mapped:true}
                  return allSeniorityMapping.push(obj)
                })
              // console.log(allOccupationsMapping,'---all ---', allSeniorityMapping)
              this.props.saveAllPositionsMapping(allOccupationsMapping,allSeniorityMapping)
              })
              if(seniorityColumn && seniorityColumn.csvField) {
                 uniqueSeniority = Object.keys(groupBy(rowData,(r) => r[seniorityColumn.csvField]));
                // console.log(uniqueSeniority)
            
                  seniority = uniqueSeniority.map((f) => {
                    const found = find(allSeniorityMapping,(o) => o.value === f);
                    if(found) {
                      return {
                        value : f,
                        column : found.column,
                        mapped:true
                      }
                    } else {
                      return {
                        value : f,
                        column : '',
                        mapped:false
                      }
                    }
                  })

                  // console.log(seniority,'--',allSeniorityMapping);
             let results = allSeniorityMapping.concat(seniority)
             let res = results.filter(e=> e.value!=null && e.value!='null').map(e=>{
               if(e.column!==""){
                 let obj = {
                   value:e.value,
                   mapped: e.mapped,
                   column: {label:e.column!==""?e.column.label:"",value: e.column?e.column.value:""}
                 }
                 return obj
               } else {
                 let val = !e.value || e.value===undefined||e.value===null ||e.value==="null"|| e.value==="undefined"? e.value="empty":e.value
                 let obj = {
                   value:val,
                   mapped: false,
                   column: ""
                 }
                 return obj
               }
             })
             res = uniqBy(res, 'value')
             allSeniorityMapping=res
             this.props.saveAllPositionsMapping(allOccupationsMapping,allSeniorityMapping)
             this.props.nextStep();
                } else {
                  allSeniorityMapping = sortBy(filter(uniqueSeniority,(s) => s != 'undefined').map((seniority) => {
                    const o = {};
                    o.value = seniority;
                    o.column = ''
                    return o;
                  }),(o) => o.value);
                  this.props.saveAllPositionsMapping(allOccupationsMapping,allSeniorityMapping)
                  this.props.nextStep();
                }
              } else {  
                // console.log(uniqueSeniority)
                allSeniorityMapping = sortBy(filter(uniqueSeniority,(s) => s != 'undefined').map((seniority) => {
                const o = {};
                o.value = seniority;
                o.column = ''
                return o;
              }),(o) => o.value);
              // console.log(allSeniorityMapping)
              this.props.saveAllPositionsMapping(allOccupationsMapping,allSeniorityMapping)
              // console.log(allOccupationsMapping)
              // console.log('222-- ',this.props)

              this.props.nextStep();
                }
            })
        } else {
          if(seniorityColumn && seniorityColumn.csvField) {
            uniqueSeniority = Object.keys(groupBy(rowData,(r) => r[seniorityColumn.csvField]));
            allSeniorityMapping = sortBy(filter(uniqueSeniority,(s) => s != 'undefined').map((seniority) => {
              const o = {};
              o.value = seniority;
              o.column = ''
              return o;
            }),(o) => o.value);
            this.props.saveAllPositionsMapping(allOccupationsMapping,allSeniorityMapping)
            this.props.nextStep();
        } else {
          this.props.saveAllPositionsMapping(allOccupationsMapping,[])
          this.props.nextStep();
        }
          
    }

  }
}

  handleMapSeniorityColumnContinue = () => {
    const {allSeniorityMapping} = this.props.mapPositions;
    // console.log(allSeniorityMapping);
    // const invalid = allSeniorityMapping.filter((o) => {
    //   if(o.column.length === 0) {
    //     return true;
    //   }
    //   return false;
    // })
    const invalidRecords = filter(allSeniorityMapping,(o) => o.mapped && !o.column && o.column!=="");
    // console.log('invalid ---', invalidRecords)
    if(invalidRecords.length>0){
      this.setState({seniorityErr:"Please map previously mapped values"})
      return
    } else {
      this.setState({seniorityErr:false})
        this.props.nextStep()
    }
    // if(invalid.length > 0) {
    //   return;
    // } else {
      // this.props.nextStep();
      // this.setState({
      //   searchedTerm : ''
      // })
    // }
  }

  handleOccupationsMapped = (occupation,column) => {
    column = column===null || column===undefined?column="":column
    const {allOccupationsMapping,allSeniorityMapping} = this.props.mapPositions;
    const allOccupations = deepClone(allOccupationsMapping);
    const i = findIndex(allOccupations,{value : occupation.value});
    allOccupations.splice(i,1,{value:occupation.value,column:column, mapped: occupation.mapped})
    this.props.saveAllPositionsMapping(allOccupations,allSeniorityMapping);
  }

  handleSeniorityMapped = (seniority,column) => {
    column = column===null || column===undefined?column="":column
    const {allOccupationsMapping,allSeniorityMapping} = this.props.mapPositions;
    const allSeniority = deepClone(allSeniorityMapping);
    const i = findIndex(allSeniority,{value : seniority.value});
    // console.log(allSeniority)
    // console.log(i)
    allSeniority.splice(i,1,{value:seniority.value,column:column, mapped:seniority.mapped})
    // console.log(allSeniority)
    this.props.saveAllPositionsMapping(allOccupationsMapping,allSeniority);
  }

  handleMatchPositionsColumn = (matchedColumns) => {
    // console.log(matchedColumns)
    let {rowData,allOccupationsMapping,allSeniorityMapping} = this.props.mapPositions;
    let {isRepeatFlow} = this.props;
    // console.log(isRepeatFlow)
    let nonNullColumns = filter(matchedColumns,(col) => col.value);
    // console.log(nonNullColumns)
    const orgID = this.props.user.organizationId._id
    const occupationColumn = find(nonNullColumns,(col) => {
      // console.log(col)
      if(Array.isArray(col.value)) {
        if( find(col.value,{value : 'occupation'}) ) {
          return col;
        }
      } else {
        if(col.value.value === 'occupation') {
          return col;
        }
      }
    });

    // console.log(occupationColumn, isRepeatFlow)
    // Object.keys(groupBy(rowData,(r) => console.log(r) ));
    let uniqueOccupations;
    uniqueOccupations =  (occupationColumn && occupationColumn.csvField? Object.keys(groupBy(rowData,(r) => r[occupationColumn.csvField])):"")


    this.props.onMatchColumn(matchedColumns);
    let occupations = [];
    if(isRepeatFlow) {
          axios.get(url.getExistingMappings(orgID)).then(({data}) => {
            // console.log('da---', data)
            const payload = data.data;
            let {mapping} = payload;
            let existM=[]
          if(mapping.occupation.data.length>0){
            allOccupationsMapping=[]
            mapping.occupation.data.map(e=>{
            let column = e.key
            let obj;
              e.values.map(c=>{
                let cVal = find(this.state.occupationOptions, {label:e.key})
                obj = {column:{value: cVal.value, label:e.key}, value: c, mapped:true}
                return allOccupationsMapping.push(obj)
              })
            console.log('all ---', allOccupationsMapping)
            this.props.saveAllPositionsMapping(allSeniorityMapping,allOccupationsMapping)
            })
            if(occupationColumn && occupationColumn.csvField) {
               uniqueOccupations = Object.keys(groupBy(rowData,(r) => r[occupationColumn.csvField]));
              console.log(uniqueOccupations)
                occupations = uniqueOccupations.map((f) => {
                  const found = find(allOccupationsMapping,(o) => o.value === f);
                  if(found) {
                    return {
                      value : f,
                      column : found.column,
                      mapped:false
                    }
                  } else {
                    return {
                      value : f,
                      column : ''
                    }
                  }
                })

                console.log(occupations,'--',allOccupationsMapping);
           let results = allOccupationsMapping.concat(occupations)
           let res = results.filter(e=> e.value!=null && e.value!='null').map(e=>{
             if(e.column!==""){
               let obj = {
                 value:e.value,
                 mapped: e.mapped,
                 column: {label:e.column!==""?e.column.label:"",value: e.column?e.column.value:""}
               }
               return obj
             } else {
               let val = !e.value || e.value===undefined||e.value===null ||e.value==="null"|| e.value==="undefined"? e.value="empty":e.value
               let obj = {
                 value:val,
                 mapped: false,
                 column: ""
               }
               return obj
             }
           })
           res = uniqBy(res, 'value')
           allOccupationsMapping = res
           this.props.saveAllPositionsMapping(allOccupationsMapping,allSeniorityMapping)
           this.props.nextStep();
              } else {
                console.log("none -----")
                occupations = sortBy(filter(uniqueOccupations,(s) => s != 'undefined').map((occupation) => {
                  const o = {};
                  o.value = occupation;
                  o.column = ''
                  return o;
                }),(o) => o.value);
                // allOccupationsMapping = occupations
                this.props.saveAllPositionsMapping(occupations,allSeniorityMapping)
                this.props.nextStep();
              }
            } else {   
              console.log("here ---", uniqueOccupations)
              occupations = sortBy(filter(uniqueOccupations,(s) => s != 'undefined').map((occupation) => {
                const o = {};
                o.value = occupation;
                o.column = ''
                return o;
              }),(o) => o.value);
              console.log("here--", occupations)
              // allOccupationsMapping = occupations
            this.props.saveAllPositionsMapping(occupations,allSeniorityMapping)
            this.props.nextStep();
              }
          }) 
      } else {
        if(occupationColumn && occupationColumn.csvField) {
          uniqueOccupations = Object.keys(groupBy(rowData,(r) => r[occupationColumn.csvField]));
          console.log(uniqueOccupations,rowData)
          occupations = sortBy(filter(uniqueOccupations,(s) => s != 'undefined').map((occupation) => {
            const o = {};
            o.value = occupation;
            o.column = ''
            return o;
          }),(o) => o.value);
          // allOccupationsMapping = occupations
          this.props.saveAllPositionsMapping(occupations,allSeniorityMapping)
          this.props.nextStep();
        } else {
          this.props.saveAllPositionsMapping([],allSeniorityMapping)
          this.props.nextStep();
        }
        
      }
  }

  handleSearchQueryChange = ({name,value}) => {
    this.setState({
      searchedTerm : value
    })
  }

  handleContinue = () => {
    const {occupationOptions,seniorityOptions} = this.state;
    const {isRepeatFlow} = this.props;
    const {matchedColumns,allSeniorityMapping,allOccupationsMapping} = this.props.mapPositions;
    const nonNullColumns = filter(matchedColumns,(col) => col.value);
    console.log(matchedColumns);
    let occupationColumn = find(nonNullColumns,(col) => {
      if(Array.isArray(col.value)) {
        console.log(col)
        if(find(col.value,{value : 'occupation'})) {
          return col;
        }
      } else {
        if(col.value.value === 'occupation') {
          return col;
        }
      }
    });
    console.log(occupationColumn)

    let seniorityColumn = find(nonNullColumns,(col) => {
      console.log(col)
      if(Array.isArray(col.value)) {
        if(find(col.value,{value : 'seniority'})) {
          return col;
        }
      } else {
        if(col.value.value === 'seniority') {
          return col;
        }
      }
    });

    console.log(seniorityColumn,allSeniorityMapping)

    console.log(occupationColumn,allOccupationsMapping)

    const groupedMappingSeniority = groupBy(allSeniorityMapping,(o) => o.column.value);
    let sData = [];
    console.log(groupedMappingSeniority)
    for(let key in groupedMappingSeniority) {
      sData.push({
        key : key,
        values : groupedMappingSeniority[key].map((o) => o.value)
      })
    }
    sData = sData.filter(o=> o.key!==undefined && o.key!=="undefined")

    let sPayload = null;
    if(seniorityColumn && seniorityColumn.csvField) {
      sPayload = {
        mappingType : "seniority",
        columnName : seniorityColumn.csvField,
        data : sData
      }
    }

    const groupedMappingOccupation = groupBy(allOccupationsMapping,(o) => o.column.value);
    let oData = [];
    console.log(groupedMappingOccupation)
    for(let key in groupedMappingOccupation) {
      oData.push({
        key : key,
        values : groupedMappingOccupation[key].map((o) => o.value)
      })
    }

    oData = oData.filter(o=> o.key!==undefined && o.key!=="undefined")
    let oPayload = null
    if(occupationColumn && occupationColumn.csvField) {
      oPayload = {
        mappingType : "occupation",
        columnName : occupationColumn.csvField,
        data : oData
      }
    }
    console.log(oPayload, sPayload);
    // let result = {
    //   occupations: oPayload,
    //   seniority: sPayload
    // }
    axios.all([
      sData.length>0 ? axios.post(url.saveMapping,sPayload) : null,
      oData.length>0 ? axios.post(url.saveMapping,oPayload) : null
    ])
    .then(axios.spread((r1, r2) => {
      if(isRepeatFlow) {
        this.props.history.push({pathname : 'success',state : {type : 'positions'}});
        this.props.reset();
      } else {
        this.props.history.push('map-performance');
      }
    }));
  }

  handleonSortChange = (sortType) => {
    this.setState({
      sortType : sortType
    });
  }

  handleSkipStep = () => {
    axios.post(url.skipStepFor('position')).then(({data}) => {
      this.props.history.push('map-performance');
    })
  }

  render() {
    let {currentStep, allColumns, rowData, file, matchedColumns, 
      allOccupationsMapping, allSeniorityMapping} = this.props.mapPositions;
    const {searchedTerm,sortType,occupationOptions,seniorityOptions} = this.state;
    console.log(this.props);
    const {isRepeatFlow} = this.props;
    console.log(seniorityOptions,"---sen---",allSeniorityMapping)
    let dropdownValues = [{value: "seniority", label: "Job Category"},{value: "occupation", label: "Occupation"}]
    return (
      <div className={"mb30" + isRepeatFlow ? 'mt30' : 'mt70'}>
      <div className="map-positions-title mt30 mb30">Map Positions</div>
        <Steps steps={mapPositionsSteps} currentStep={currentStep} />
        {
          currentStep === 1 ? 
          <UploadFile
            top="mt40"
            instruction={uploadFileInstruction.mapPositions}
            allColumns={allColumns}
            rowData={rowData}
            file={file}
            type={mapType.positions}
            labelSize={3}
            labelText="File with Positions"
            allowedFileSize={20}
            uploadFileHint="(Only .csv files, maximum 20MB file size)"
            onFileUpload={this.handleFileUpload}
            onSkipStep={this.handleSkipStep}
            isRepeatFlow={isRepeatFlow}
          /> : 
          currentStep === 2 ?
            <MatchColumns
              goBack={this.props.goBack}
              top="mt40"
              dropdownValues={dropdownValues}
              instruction={`Match up to 2 columns relating to employee positions. Select 
              “Occupations” if the column contains information about occupation types, 
              “Job Category” if it concerns the seniority of the position or select both if the 
              data in the column contains information about both “Occupations” and “Job Category”.`}
              csvFields = {allColumns}
              csvData = {rowData}
              type={mapType.positions}
              showDropdown={true}
              mappingPositions={true}
              allowDropdownMultiselect={true}
              matchedColumns={matchedColumns}
              allowMoreColumnsMatch={true}
              nextBtnTxt='Continue'
              onMatchedColumns={this.handleMatchPositionsColumn}
            /> : 
          currentStep === 3 ?
            <MapColumns
              allDataMapping={allOccupationsMapping}
              mapOptions={occupationOptions}
              error={this.state.occupationErr}
              onRowMapped={this.handleOccupationsMapped}
              nextStep={this.handleMapOccupationColumnContinue}
              goBack={this.props.goBack}
              searchedTerm={searchedTerm}
              sortType={sortType}
              onSearchQueryChange={this.handleSearchQueryChange}
              onSortChange={this.handleonSortChange}
              type={mapType.positions}
              mapSelectPlaceholder="Map to occupation"
              optionTypeTxt="Name"
              mappingTableHeader="Position Name"
              searchBarPlaceholder="Search by position name"
              mappingSubHeaderTxt="Please map the positions within your enterprise to standardized occupational categories."
            /> :
          currentStep === 4 ?
            <MapColumns
              allDataMapping={allSeniorityMapping}
              mapOptions={seniorityOptions}
              error={this.state.seniorityErr}
              type={mapType.positions}
              onRowMapped={this.handleSeniorityMapped}
              nextStep={this.handleMapSeniorityColumnContinue}
              goBack={this.props.goBack}
              searchedTerm={searchedTerm}
              sortType={sortType}
              onSearchQueryChange={this.handleSearchQueryChange}
              onSortChange={this.handleonSortChange}
              mapSelectPlaceholder="Map to job category"
              optionTypeTxt="Name"
              mappingTableHeader="Position Name"
              searchBarPlaceholder="Search by position name"
              mappingSubHeaderTxt='Please map the positions in your organization to standardized Job Categories. Note that all the unmapped positions will be assigned to a “Non-managerial” level.'
            /> :
            currentStep === 5 ?
            <Review
              top="mt40"
              instruction={reviewInstruction.mapPositions}
              goBack={this.props.goBack}
              nextBtnAction={this.handleContinue}
              mapOccupationOptions={occupationOptions}
              mapSeniorityOptions={seniorityOptions}
              type={mapType.positions}
              file={file}
              nextBtnTxt={isRepeatFlow ? 'Finish' : 'Next Step'}
              isRepeatFlow={isRepeatFlow}
              reviewHeading="These are your final selections for the mapping. "
              {...this.props}/>
            :
            null
        }
    </div>
    );
  }
}
